// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Stock_GetResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response Contract for GET /so/stock/get/{product_id}
 *
 * Returns the stock record for a specific product in the first franchise
 * of the current filter. Wire shape: `dados: Stock_StockRow`.
 *
 * @see Stock_StockRow
 * @see So_stock_model::getByProduct()
 */
import type { Stock_StockRow } from './Stock_StockRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Stock_GetResponseDados = Stock_StockRow;

export type Stock_GetResponse = ApiResponse<Stock_GetResponseDados>;

registerResponseContract('Stock_GetResponse', {
  so_stock_id:               { type: 'number',  required: true },
  so_stock_product_id:       { type: 'number',  required: true },
  so_stock_quantity:         { type: 'number',  required: true },
  so_stock_minimum_quantity: { type: 'number',  required: true },
  so_stock_location_id:      { type: 'number',  required: false },
  so_stock_franchise_id:     { type: 'number',  required: true },
  so_stock_updated_at:       { type: 'string',  required: false },
  so_product_name:           { type: 'string',  required: false },
  so_stock_price:            { type: 'number',  required: false },
})
